/* eslint-disable @stylistic/comma-dangle */

import { messages as commonLocale }	from "@geotoura/common/locale_en";
import { sharedLocale }				from "@geotoura/shared/sharedLocale_en";
import { siteInfo }					from "@geotoura/shared/siteInfo_en";

export const messages = {
	general: {
		and:			"and",
		cancel:			"Cancel",
		category:		"Category",
		close:			"Close",
		closeDialog:	"Close dialog",
		defHotel:		"Location with hand-picked hotels",
		defDaytrip:		"Destination",
		defAirport:		"City with airport",
		help:			"Help",
		impressum:		{ href: siteInfo.page.impressum, text: "Impressum" },
		night:			"Night",
		nights:			"Nights",
		remove:			"remove",
		stop:			"Stop",
		stops:			"Stops",
	},
	activitylist: {
		title:	"Experiences",
		intro:	"For us, a perfect trip includes not only handpicked hotels, but also unique experiences. You can book the following offers when you visit this city.",
	},
	app: {
		contentShow:	"Show content",
		contentHide:	"Hide content",
	},
	counter: {
		up:		"increase by one",
		down:	"decrease by one"
	},
	destination: {
		scrollTop:	"Up to the top"
	},
	destinationInfo: {
		addToRoute:			"Add to my route",
		addToRouteShort:	"My route",
		removeFromRoute:	"Remove from my route",
		station:			(nr:string):string => `Station ${nr}`,
		stationSuffix:		" of the route",
		removeInRoute:		"Remove and move to the next location",
		nights: {
			nrnights:				"Overnight stays",
			nrnightsShort:			"Nights",
			recommendedStay:		"Our recommendation: ",
			recommendedStayShort:	"Our tip:",
			labelPlus:				"Increase nights by one",
			labelMinus:				"Decrease nights by one",
		}
	},
	footer: [
		{ href: siteInfo.page.privacy,		text: "Privacy" },
		{ href: siteInfo.page.arb,			text: "General Terms and Conditions of Travel" },
		{ href: siteInfo.page.impressum,	text: "Legal notice" }
	],
	gallery: {
		fotos:	"Photos",
	},
	hotel: {
		selectCategory:	"Select hotel",
		selected:		"Selected hotel"
	},
	hotelFeatured: {
		note:			"Note",
		severalCats:	"This hotel appears in several hotel categories because it has rooms for different quality requirements."
	},
	hotelList: {
		title:		"Hotels",
		catIntro:	"When we include a hotel in our programme, it is not only a high standard of quality that is important to us. We also favour typical local accommodation with a special ambience. We divide our hotels into four separate Geotoura categories.",
		cat1:		"Our most affordable option. Lovingly furnished rooms that offer everything the discerning traveller expects.",
		cat2:		"Hotels with a special ambience: Historic palaces, monasteries, haciendas or beach hotels with extraordinary charm. Perfect for a classic cultural tour.",
		cat3:		"Luxurious hotels in excellent locations and with the highest level of comfort, often in centuries-old aristocratic palaces, old oil mills or haciendas.",
		cat4:		"For the honeymoon – span. Luna de miel – or if you want to treat yourself to something out of the ordinary …",
	},
	help: {
		title:	"How the Geotoura travel planner works",
		step1: {
			title:	"Select your desired destinations on the map",
		},
		step2: {
			title:	"Add the locations to your route",
			text:	"Choose from our sightseeing tips, hotels and events where you want to go and what you want to experience there.",
		},
		step3: {
			title:	"Request your free travel offer",
			text:	"You will receive a free and non-binding offer for your customised individual trip by e-mail.",
		},
		outro:			"If everything fits, you can book exactly this trip with us – we take care of everything: flight, rental car, hotels and all the little extras that make a trip with Geotoura special.",
		buttonTitle:	"Let's go!"
	},
	howtoStart: {
		title:	"A dream holiday, very simple and entirely to your taste",
		step1: {
			title:			"Select route",
			withoutRoute:	"Without route",
		},
		step2: {
			title:	"Customise stations",
			text:	"Hotels, excursions and experiences, choose from our sightseeing tips according to your wishes",
		},
		step3: {
			title:	"Request a dream route",
			text:	"You will receive a free and non-binding offer with customised suggestions by e-mail.",
		},
		outro:			"Once you have put together your dream trip, we take care of the rest: flights, rental cars, hotels and all the little extras that make a trip with Geotoura special.",
		buttonTitle:	"Plan your route now"
	},
	howtoHelp: {
		title:		"How the Geotoura travel planner works",
		step1: {
			title:	"Select your desired destinations on the map",
		},
		step2: {
			title:	"Add the locations to your route",
			text:	"Choose from our sightseeing tips, hotels and events where you want to go and what you want to experience there.",
		},
		step3: {
			title:	"Request your free travel offer",
			text:	"You will receive a free and non-binding offer for your customised trip by e-mail.",
		},
		outro:			"If everything fits, you can book exactly this trip with us – we take care of everything: flight, rental car, hotels and all the little extras that make a trip with Geotoura special.",
		buttonTitle:	"Let's go!"
	},
	legend: {
		title:	"Legend",
	},
	lightbox: {
		title:		"Lightbox",
		previous:	"Show previous image",
		next:		"Show next image"
	},
	nearbylist: {
		title:	"Next destinations"
	},
	nearby: {
		hintHotel:		"We offer hotels at this location",
		hintDaytrip:	"A worthwhile day trip",
	},
	overwriteRoute: {
		title:				"Saved route found",
		message1:			"You arrived here via a link that loads a route put together by Geotoura.",
		message2:			"However, your browser already contains a route with ",
		message3:			" saved from a previous visit to the holiday planner. Which route do you want to continue with?",
		cancelTitle:		"Keep saved route",
		confirmTitle:		"Load Geotoura route",
	},
	territorylist: {
		entryUrl:	siteInfo.page.main,
		intro:		"Where do you want to travel?",
		logo:		"logo-white-DE.svg"
	},
	request: {
		title:				"Send me a travel offer",
		buttonRequest:		"Request a non-binding and free offer",
		buttonRequestShort:	"Request a free offer",
		buttonCancel:		"Cancel",
	},
	form: commonLocale.form,
	requestform: {
		flight: {
			labelChecked:	"Organise my travel from",
			label:			"Organise my travel"
		},
		postCode:{
			label:			"Postal code",
			placeholder:	"Postal code",
		},
		country:{
			label:	"Country",
		},
		nrAdults: {
			label:	"Adults"
		},
		nrBabies: {
			label:	"Children (0-2 years)"
		},
		kids:	"Children",
		nrKids: {
			label:	"Children (3-11 years)"
		},
		roomSingle: {
			label:	"Single room"
		},
		roomDouble: {
			label:	"Double room"
		},
		kidBeds: {
			label:	"Extra beds"
		},
		babyBeds: {
			label:	"Baby beds"
		},
		duration: {
			label:	"Desired travel duration"
		},
		startIntro:	"I would like to travel between",
		start: {
			label:	"Start date",
		},
		end: {
			label:	"End date",
		},
		rentalCar: {
			label:	"Organise a rental car"
		},
		rentalCarCategory: {
			label:	"Car rental category"
		},
		hotelCategory: {
			label:	"Hotel category"
		},
		notes: {
			label:			"Notes",
			placeholder:	"Do you have any special requirements, such as accessibility, or requests for your trip? There's room for them here.",
		},
	},
	requestroute: {
		title:		"Travel route",
		noOffer:	"You have not yet selected any destinations. Configure your personalised dream trip on the previous page or write us your comments and we will be happy to help you.",
		show:		"Show details",
		hide:		"Hide details"
	},
	requestSuccess: {
		title:		"Thank you for your enquiry",
		text1:		"You should receive a confirmation e-mail with your travel details shortly. One of our employees will use your details to create a personalised travel offer for you.",
		text2:		"We will usually get back to you within 24 hours. Please understand that it may take a little longer at the weekend. We respond to all weekend enquiries from Monday morning.",
		text3:		"Your itinerary remains saved in your browser so that you can view and change it later.",
		greetings:	"Best regards from Heidelberg",
		signature:	"Your Geotoura team",
	},
	requestError: {
		title:	"Error when submitting",
		text:	"Unfortunately, an error occurred while sending and your enquiry could not be sent. However, your route remains saved in your browser. Please try again at another time or contact us directly at",
		link:	sharedLocale.phone,
	},
	routeDelete: {
		title:			"Do you really want to delete the route?",
		message:		"This action deletes your entire route.",
		confirmTitle:	"Delete route"
	},
	route: {
		title:		"My route",
		stop:		"Station",
		stops:		"Stations",
		night:		"Night",
		nights:		"Nights",
		activity:	"Activity",
		activities:	"Activities",
		wish:		"Wish",
		wishes:		"Wishes",
		clearRoute:	"Delete entire route",
		request:	"Request an offer",
		empty:		"You don't have any stops on your route yet. Click on a destination on the map to add stops to your route!",
		back:		"Back to the map",
	},
	routebar: {
		showRoute:			"Show route",
		hideRoute:			"Hide route",
		showDestination:	"Show location description",
		hideDestination:	"Hide location description",
		summary: {
			stops:		"Stations",
			hotels:		"Nights",
			activities:	"Activities",
			wishes:		"Wishes",
			request:	"Request",
		},
		station:		"Station",
		currentStation:	"Current location",
		previous:		"To the previous location in the route",
		next:			"To the next location in the route",
		back:			"Back to the Geotoura homepage"
	},
	routestop: {
		wish:				"Wishes",
		removeWish:			"Remove wish",
		removeActivity:		"Remove activity",
		activeDestination:	"Current destination",
		addToRoute:			"Add to route",
		moveUp:				"Move up",
		moveDown:			"Move down",
		showDestination:	"To the location description"
	},
	search: {
		placeholder:	"Search location",
		label:			"Search location",
		noMatches:		"no results for your search",
		clearInput:		"Clear input"
	},
	sights: {
		show:		"more information",
		hide:		"less information",
		h3Title:	"More about the location"
	},
	wish: {
		title:			"Special wishes",
		info:			"Let us know what you would like to do or experience – our local staff will organise it for you.",
		placeholder:	"Would you like us to organise something special for you at this location? A concert, an evening at the opera or a picnic in the park? There is room for your wishes here …",
		add:			"Add wish to route",
		change:			"change",
		label:			"Wish",
	},
};
